import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { apiErrorAtom } from "../../store";

// This is a simple wrapper around Jotai
// to reduce imports in components. e.g.
//   const [apiError, setApiError] = useApiError();
export const useApiError = () => useAtom(apiErrorAtom);

export const useApiErrorValue = () => useAtomValue(apiErrorAtom);

export const useSetApiError = () => useSetAtom(apiErrorAtom);
